// @ts-nocheck
import React from 'react';
import classNames from 'classnames';
import Trigger from '../../trigger/trigger';
import builtinPlacements from '../../utils/builtinPlacements';
import NavigationContext from '../context/NavigationContext';
import { KEY_VALUES, getActiveElement } from '../../utils';
var PopupMenu = function PopupMenu(props) {
  var _props$action = props.action,
    action = _props$action === void 0 ? ['click'] : _props$action,
    menuDataItem = props.menuDataItem,
    width = props.width,
    level = props.level,
    indexPath = props.indexPath,
    onClickSubItem = props.onClickSubItem,
    onLeft = props.onLeft,
    onEsc = props.onEsc,
    onSelectedKeyChange = props.onSelectedKeyChange,
    id = props.id,
    onClose = props.onClose;
  var _React$useContext = React.useContext(NavigationContext),
    selectedIndexListStore = _React$useContext.selectedIndexListStore,
    selectedIndexListDispatch = _React$useContext.selectedIndexListDispatch;
  var triggerRef = React.useRef(null);
  var childRef = React.useRef(null);
  React.useEffect(function () {
    var _childRef$current;
    var keyboard = selectedIndexListStore.keyboard;
    var liEle = (_childRef$current = childRef.current) === null || _childRef$current === void 0 ? void 0 : _childRef$current.querySelector('li');
    if (keyboard) {
      liEle === null || liEle === void 0 ? void 0 : liEle.focus();
    }
  }, []);
  var getNextFocusableElement = function getNextFocusableElement(findElement, element, isPre) {
    if (isPre === void 0) {
      isPre = false;
    }
    var controls = "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])";
    var focusable = findElement === null || findElement === void 0 ? void 0 : findElement.querySelectorAll(controls);
    var length = focusable.length;
    var index = Array.prototype.indexOf.call(Array.from(focusable), element);
    return Array.from(focusable)[isPre ? index === -1 ? length - 1 : index - 1 : index + 1];
  };
  var selectedIndexList = selectedIndexListStore.selectedIndexList;
  var _React$useState = React.useState(''),
    currentIndex = _React$useState[0],
    setCurrentIndex = _React$useState[1];
  var selctedIndexPath = String(selectedIndexList.slice(0, level + 1).join('-'));
  var handleItemKeydown = function handleItemKeydown(event, item, index) {
    var key = event.key;
    var isEnter = key === KEY_VALUES.ENTER;
    setCurrentIndex(index);
    var nextSelectedIndexList = indexPath.split('-').concat(String(index)).map(function (item) {
      return Number(item);
    });
    var nextSubSelectedIndexList = nextSelectedIndexList.slice(1);
    var isLeaf = !item.children || item.children.length === 0;
    if (isEnter && isLeaf) {
      if (onSelectedKeyChange) {
        onSelectedKeyChange === null || onSelectedKeyChange === void 0 ? void 0 : onSelectedKeyChange(event, item, item.key);
      } else {
        onClickSubItem && onClickSubItem(event, item, nextSubSelectedIndexList.join('-'), selectedIndexList[0]);
        if (!selectedIndexListStore.isControlled) {
          selectedIndexListDispatch({
            type: 'setSelectedIndexList',
            payload: {
              nextSelectedIndexList: nextSelectedIndexList
            }
          });
        }
      }

      // const { key } = item;
      // const rootKey = key.split('-')[0];
      onClose === null || onClose === void 0 ? void 0 : onClose();
      selectedIndexListDispatch({
        type: 'setOpenPopup',
        payload: {
          openPopup: false
        }
      });
      // focus

      // const ele = document.querySelector(`.item-${rootKey}`);
      // ele?.focus();
    }
  };

  var handleItemClick = function handleItemClick(event, item, index) {
    setCurrentIndex(index);
    var nextSelectedIndexList = indexPath.split('-').concat(String(index)).map(function (item) {
      return Number(item);
    });
    var nextSubSelectedIndexList = nextSelectedIndexList.slice(1);
    var isLeaf = !item.children || item.children.length === 0;
    if (event.type === 'click' && isLeaf) {
      if (onSelectedKeyChange) {
        onSelectedKeyChange === null || onSelectedKeyChange === void 0 ? void 0 : onSelectedKeyChange(event, item, item.key);
      } else {
        onClickSubItem && onClickSubItem(event, item, nextSubSelectedIndexList.join('-'), selectedIndexList[0]);
        if (!selectedIndexListStore.isControlled) {
          selectedIndexListDispatch({
            type: 'setSelectedIndexList',
            payload: {
              nextSelectedIndexList: nextSelectedIndexList
            }
          });
        }
      }
      onClose === null || onClose === void 0 ? void 0 : onClose();
      selectedIndexListDispatch({
        type: 'setOpenPopup',
        payload: {
          openPopup: false
        }
      });
    }
  };
  var onKeyDown = function onKeyDown(e) {
    var key = e.key;
    var isDown = key === KEY_VALUES.DOWN;
    var isUp = key === KEY_VALUES.UP;
    var isLeft = key === KEY_VALUES.LEFT;
    var isEsc = key === KEY_VALUES.ESC;
    var isTab = key === KEY_VALUES.TAB;
    var container = e.target.closest('.ap-popup.ap-dropdown-list');
    if (container !== childRef.current) {
      if (isLeft) {
        triggerRef.current.triggerOpen(false);
        e.stopPropagation();
        var path = event.target.dataset['parent'];
        var pathArr = path.split('-');
        var _index = pathArr[pathArr.length - 1];
        var listEles = childRef.current.querySelectorAll('.ap-list-item');
        if (listEles[_index]) {
          listEles[_index].focus();
        }
      }
      return;
    }
    if (isTab) {
      var element = getActiveElement();
      var nextEle = getNextFocusableElement(container, element);
      if (!nextEle) {
        var controls = "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden]),\n  [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])";
        var focusable = container.querySelectorAll(controls);
        if (focusable && focusable.length > 0) {
          focusable[0].focus();
          e.preventDefault();
        }
      }
    }
    if (isDown) {
      e.preventDefault();
      var _element = getActiveElement();
      var _nextEle = getNextFocusableElement(container, _element);
      if (!_nextEle) {
        _nextEle = getNextFocusableElement(container, null);
        _nextEle && _nextEle.focus();
      } else {
        _nextEle && _nextEle.focus();
      }
    } else if (isUp) {
      e.preventDefault();
      var _element2 = getActiveElement();
      var preEle = getNextFocusableElement(container, _element2, true);
      if (!preEle) {
        preEle = getNextFocusableElement(container, null, true);
        preEle && preEle.focus();
      } else {
        preEle && preEle.focus();
      }
    } else if (isLeft) {
      onLeft === null || onLeft === void 0 ? void 0 : onLeft(indexPath);
    } else if (isEsc) {
      onClose === null || onClose === void 0 ? void 0 : onClose(true, indexPath);
    }
  };
  if (!menuDataItem || menuDataItem.length === 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var popupDropdownListCls = classNames('ap-popup', 'ap-dropdown-list');
  return /*#__PURE__*/React.createElement("div", {
    className: popupDropdownListCls,
    onKeyDown: onKeyDown,
    ref: childRef,
    id: id,
    role: "menu"
  }, menuDataItem.map(function (item, index) {
    var isLeaf = !item.children || item.children.length === 0;
    var popupDropdownListItemCls = classNames('ap-list-item', {
      selected: selctedIndexPath === indexPath + "-" + index && selectedIndexList[level] == index,
      isLeaf: isLeaf
    });
    return /*#__PURE__*/React.createElement(Trigger, {
      ref: triggerRef,
      popupClassName: "ap-navigation-popup",
      autoDestroy: true,
      builtinPlacements: builtinPlacements(false),
      key: String(index),
      action: action,
      popupPlacement: 'right',
      "aria-control": true,
      popup: String(index) === currentIndex && /*#__PURE__*/React.createElement(PopupMenu, {
        action: action,
        indexPath: indexPath + "-" + index,
        placement: "right",
        width: width,
        menuDataItem: item.children || [],
        name: item.name,
        level: level + 1,
        onClickSubItem: onClickSubItem,
        onSelectedKeyChange: onSelectedKeyChange,
        onClose: onClose
      })
    }, /*#__PURE__*/React.createElement("li", {
      tabIndex: 0,
      style: {
        width: width
      },
      role: "menuitem",
      className: popupDropdownListItemCls,
      key: String(index),
      onMouseEnter: function onMouseEnter(event) {
        return handleItemClick(event, item, String(index));
      },
      "data-parent": indexPath,
      onClick: function onClick(event) {
        return handleItemClick(event, item, String(index));
      },
      onKeyDown: function onKeyDown(event) {
        return handleItemKeydown(event, item, String(index));
      },
      "aria-haspopup": isLeaf ? 'false' : 'true',
      "aria-expanded": String(index) === currentIndex ? 'true' : 'false',
      "aria-label": item.name,
      "aria-selected": selctedIndexPath === indexPath + "-" + index ? 'true' : 'false'
    }, item.name, !isLeaf && /*#__PURE__*/React.createElement("span", {
      className: "Appkit4-icon icon-caret-down-fill icon-collapsed"
    })));
  }));
};
PopupMenu.displayName = 'PopupMenu';
export default PopupMenu;